export interface PropertyTenant {
  abr?: number;
  annual_rent?: string;
  base_monthly_rent?: number;
  created_at?: Date | string;
  description?: string;
  expense_recovery?: number;
  file_resources?: any[];
  gross_rent?: number;
  id?: number;
  interior_sq_ft?: string;
  is_grocer?: boolean;
  lease_end_date?: any;
  lease_start_date?: any;
  maintenance?: string;
  name?: string;
  occupancy_end_date?: string;
  occupancy_start_date?: string;
  percentage_rent?: number;
  price_per_sq_ft?: number;
  property_id?: number;
  property_unit_id?: number;
  rent_escalations?: RentEscalation[];
  sales?: number;
  updated_at?: Date | string;
}

export interface PropertyUnit {
  id?: number;
  custom_field_values?: any[];
  property_id?: number;
  unit_number?: string;
  unit_size?: number;
  floor?: number;
  property_tenant?: PropertyTenant;
  property_tenants?: PropertyTenant[];
  property_name?: string;
  facility_reports?: any;
}

export interface RentEscalation {
  id?: number;
  start_date?: any;
  start_month?: number;
  amount?: number;
  schedule_units?: number;
  escalation_units?: number;
}

export const RENT_ESCALATION_UNITS = [
  { name: 'amount_per_sf_per_year', label: '$/SF/Year' },
  { name: 'amount_per_sf_month', label: '$/SF/Month' },
  { name: 'amount_per_year', label: '$/Year' },
  { name: 'amount_per_month', label: '$/Month' },
  { name: 'percent_per_year', label: '%/Year' },
  { name: 'percent_per_month', label: '%/Month' },
  { name: 'percent_per_year_annual', label: '%/Year, Annual' },
];
